import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: ${(p) => p.theme.layout.maxw}px;
  margin: 0 auto;
  padding: 0 ${(p) => p.theme.layout.gutter}px;
`;
